import React from "react";
import { InfoCircleIcon } from "../../atoms/InfoCircleIcon";
import { KgMetricIcon } from "../../atoms/KgMetricIcon";
import { KgCollapsedNodeHover } from "../KgCollapsedNodeHover";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  IconBox,
  Label,
  LabelRow,
  Name,
  Pill,
  TextStack,
} from "./KgMetricNodeCard.styles";
import type { KgMetricNodeCardProps } from "./KgMetricNodeCard.types";

export const KgMetricNodeCard: React.FC<KgMetricNodeCardProps> = ({
  name,
  hasWarning = false,
  collapsed = false,
  visualState = "default",
  isSelected = false,
  onClick,
}) => {
  if (collapsed) {
    return (
      <KgCollapsedNodeHover
        icon={<KgMetricIcon size={16} />}
        color={rawColors.accent.metricBlue}
        bgColor={rawColors.accent.metricBlueBg}
        visualState={visualState}
        title={name}
        subtitle="Metric"
      />
    );
  }

  return (
    <Pill $visualState={visualState} $isSelected={isSelected} onClick={onClick} role="group" tabIndex={0}>
      <IconBox>
        <KgMetricIcon size={16} />
      </IconBox>
      <TextStack>
        <LabelRow>
          <Label>Metric</Label>
          {hasWarning && <InfoCircleIcon size={12} color={rawColors.accent.warningYellow} />}
        </LabelRow>
        <Name title={name}>{name}</Name>
      </TextStack>
    </Pill>
  );
};

export default KgMetricNodeCard;
